/** Durée de conservation des brouillons de réponse forum (localStorage). */
export const FORUM_REPLY_DRAFT_TTL_MS = 3 * 24 * 60 * 60 * 1000;

const KEY_PREFIX = 'webtarot.forums.replyDraft.';

interface DraftEntry {
  body: string;
  updatedAt: number;
}

export function forumReplyDraftKey(
  space: string,
  pseudo: string,
  forumScope: string,
  threadId: number,
): string {
  return `${KEY_PREFIX}${space}.${pseudo.toLowerCase()}.${forumScope}.t${threadId}`;
}

export function forumReplyDraftScope(forum: {
  id: number;
  kind?: 'public' | 'team' | 'division' | 'annonces';
  teamId?: number;
  divisionId?: number;
}): string {
  if (forum.kind === 'team' && forum.teamId) return `team:${forum.teamId}`;
  if (forum.kind === 'division' && forum.divisionId) return `division:${forum.divisionId}`;
  if (forum.kind === 'annonces') return 'annonces';
  return `public:${forum.id}`;
}

export function divisionForumReplyDraftScope(opts: {
  teamId?: number;
  forumBucketId: number;
}): string {
  if (opts.teamId != null) return `team:${opts.teamId}`;
  return `division:${opts.forumBucketId}`;
}

function parseDraftEntry(raw: string | null): DraftEntry | null {
  if (!raw) return null;
  try {
    const entry = JSON.parse(raw) as DraftEntry;
    if (typeof entry.body !== 'string' || typeof entry.updatedAt !== 'number') return null;
    if (Date.now() - entry.updatedAt > FORUM_REPLY_DRAFT_TTL_MS) return null;
    return entry;
  } catch {
    return null;
  }
}

export function loadForumReplyDraft(key: string): string {
  try {
    const entry = parseDraftEntry(localStorage.getItem(key));
    if (!entry) {
      localStorage.removeItem(key);
      return '';
    }
    return entry.body;
  } catch {
    return '';
  }
}

export function saveForumReplyDraft(key: string, body: string): void {
  const trimmed = body.trim();
  try {
    if (!trimmed) {
      localStorage.removeItem(key);
      return;
    }
    const entry: DraftEntry = { body, updatedAt: Date.now() };
    localStorage.setItem(key, JSON.stringify(entry));
    pruneExpiredForumReplyDrafts();
  } catch { /* private mode */ }
}

export function clearForumReplyDraft(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch { /* private mode */ }
}

function pruneExpiredForumReplyDrafts(now = Date.now()): void {
  try {
    const toRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key?.startsWith(KEY_PREFIX)) continue;
      const entry = parseDraftEntry(localStorage.getItem(key));
      if (!entry || now - entry.updatedAt > FORUM_REPLY_DRAFT_TTL_MS) {
        toRemove.push(key);
      }
    }
    toRemove.forEach((k) => localStorage.removeItem(k));
  } catch { /* ignore */ }
}
